export const FlashMessage = (() => {
	enum FlashMessageType {
		SUCCESS = 'success',
		ERROR = 'error',
		WARNING = 'warning',
		INFO = 'info',
		NOTICE = 'notice',
	}

	const type2styleMap = {
		[FlashMessageType.SUCCESS]: {
			color: 'bg-emerald-600',
			icon: 'check',
		},
		[FlashMessageType.ERROR]: {
			color: 'bg-red-600',
			icon: 'exclamation-circle',
		},
		[FlashMessageType.WARNING]: {
			color: 'bg-yellow-600',
			icon: 'exclamation-triangle',
		},
		[FlashMessageType.INFO]: {
			color: 'bg-blue-600',
			icon: 'info-circle',
		},
		[FlashMessageType.NOTICE]: {
			color: 'bg-gray-600',
			icon: 'info-circle',
		},
	}

	const show = (message: string, type: FlashMessageType = FlashMessageType.SUCCESS) => {
		const style = type2styleMap[type]
		const html = `
        <div>
          <div class="flex items-center">
            <i class="fa-light fa-${style.icon} align-middle pr-3"></i>
            <span>${message}</span>
          </div>
        </div>
        <button type="button" class="toast-dismiss shrink-0 cursor-pointer pl-4 opacity-80 hover:opacity-100 appearance-none focus:outline-none focus-visible:outline-none" aria-label="Close">
          <i class="fa-light fa-times align-middle"></i>
        </button>`

		M.toast({
			html,
			displayLength: 6500,
			classes: style.color,
		})
	}

	let dismissHandlerRegistered = false

	const registerDismissHandler = () => {
		if (dismissHandlerRegistered) {
			return
		}
		dismissHandlerRegistered = true

		document.addEventListener('click', (event) => {
			if (!(event.target instanceof Element)) {
				return
			}

			const toastElement = event.target.closest('.toast-dismiss')?.closest('.toast')
			if (toastElement === null || toastElement === undefined) {
				return
			}

			M.Toast.getInstance(toastElement).dismiss()
		})
	}

	return {
		show,
		registerDismissHandler,
	}
})()
